import { render } from "./ConsentComponent.vue?vue&type=template&id=1721d087"
import script from "./ConsentComponent.vue?vue&type=script&lang=js"
export * from "./ConsentComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__